import * as Yup from 'yup';

export const ActivityFormSchema = () =>
  Yup.object({
    code: Yup.string().default('').required(),
    name: Yup.string().default('').required(),
    description: Yup.string(),
    type: Yup.string().default('').required(),
    email: Yup.string().email().nullable().default(''),
    phone: Yup.string().nullable().default(''),
    phone_2: Yup.string().nullable().default(''),
  });

export type ActivityFormType = Yup.InferType<
  ReturnType<typeof ActivityFormSchema>
>;
